export default {
  REPLACEABLE_POINT: "商品への交換や、他の方への贈与に利用できるポイントです。",
  REPLACEABLE_POINT_EXCHANGE_ONLY: "商品への交換に利用できるポイントです。",
  THANKS_ONLY_POINT: "他の方への贈与に特化したポイントです。ご自身で商品と交換することはできません。",
  THANKS_ONLY_POINT_SUPPLEMENT: "他の方への贈与に特化したポイントです。ご自身で商品と交換することはできません。\n※贈与時は商品交換可能ポイントより優先で使用されます。",
  LATEST_MESSAGE: "直近に行われたやりとりを確認できます。"
};
